import * as joint from "jointjs";

export const boundaryTool = new joint.elementTools.Boundary({
  focusOpacity: 0.5,
  padding: 10,
  useModelGeometry: true,
});
